export class DropdownVenueModel {
    constructor(public id: string, public text: string, public disabled: boolean, public isVisibleToMainInvitee?: boolean, public isVisibleToGuests?: boolean) { }
}

export class DropdownVenueModelSegments {
    constructor(public id: string, public text: string, public disabled: boolean, public isVisibleToMainInvitee: boolean, public isVisibleToGuests: boolean) { }
}
